import axios from 'axios';

const axiosInstance = axios.create({
  withCredentials: true,
});

export function init({ insightsApiBaseUrl }) {
  axiosInstance.defaults.baseURL = insightsApiBaseUrl;
}

export default axiosInstance;
export const CancelToken = axios.CancelToken;
export type ApiDateType = string;
